import React from 'react';
import PropTypes from 'prop-types';

export const AddOnLabel = ({ addOn }) => (
    <div className='tw-w-full tw-flex tw-justify-between tw-items-center'>
        <span className='tw-text-[16px] tw-font-normal'>{addOn.name}</span>
        <span className='tw-text-[16px] tw-font-medium'>${addOn.priceChange.toFixed(2)}</span>
    </div>
);
AddOnLabel.propTypes = {
    addOn: PropTypes.shape({
        name: PropTypes.string,
        priceChange: PropTypes.number
    }).isRequired
};
